
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, watch, reactive, onMounted, defineComponent} from 'vue';
import {getActivityBaseConfig} from "../../utils/config-helper";
import {addParamsToUrl, assertData, fetcher} from "../../utils/utils";
import {BasePriceStruct} from "../../utils/structs";
// @ts-ignore
import Popper from 'vue3-popper/dist/popper.esm';
export default defineComponent({
    name: "BasePrice",
    components: {
        Popper
    },
    props: {
        activityId: {
            type: String,
            required: true,
        },
        selectedDate: {
            type: String,
            required: true,
        }
    },

    setup(props, {emit}) {
        const basePriceConfig = ref<object>({});

        const fetchData = async () => {
            const params = {
                activityId: props.activityId,
                ...(props.selectedDate !== "" && {selectedDate: props.selectedDate}),
            };

            let url = getActivityBaseConfig().basePrice;
            url = addParamsToUrl(url, new URLSearchParams(params));
            await fetcher(url).then((result) => {
                assertData(result, BasePriceStruct, 'BasePrice: fetchData Error', '<small>URL: ' + url + '</small>', 'danger');
                basePriceConfig.value = result;
            }).catch((error) => {
                console.log(error);
            });
        };

        onMounted(() => {
            fetchData();
        });

        watch(() => [props.selectedDate], (first, second) => {
            fetchData();
        });

        return {
            basePriceConfig,
            translate
        }
    }
})
